import {
  UPDATE_STATE_TO_CHANGE_TO,
  RESET_STATE_TO_CHANGE_TO
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const updateStateToChangeTo = (prevState, { state }) => state

const stateToChangeToReducer = createReducer('', {
  [UPDATE_STATE_TO_CHANGE_TO]: updateStateToChangeTo,
  [RESET_STATE_TO_CHANGE_TO]: () => ''
})

export default combineReducers({
  stateToChangeTo: stateToChangeToReducer
})
